<template>
  <div class="modal-content">
    <div class="modal-body" style="height: 630px">
      <div class="row">
        <div class="col-md-12">
          <h3>{{ _('MobilePay') }}</h3>
          <p>{{ _('Please scan the customer\'s QR code or enter their phone number manually.') }}</p>
          <button v-if="!isPhoneNumberInputVisible" type="button" class="btn btn-primary" v-on:click="enablePhoneNumberInput"><i class="fa fa-keyboard fa-fw"></i> {{ _('Enter phone number') }}</button>
          <phone-number-input v-else ref="mobilepayphone" v-model="manualMobilepayPhoneNumber" :placeholder="_('Phone number')" />
          <p v-if="phoneNumberError" class="text-danger">{{ phoneNumberError }}</p>
          <div v-if="mobilePayQrCodeUrl">
            <h3>{{ _('Event code') }}</h3>
            <img :src="mobilePayQrCodeUrl" style="max-width: 100%" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" v-on:click="close"><i class="fa fa-close fa-fw"></i>{{ _('Close') }}</button>
      <button v-if="isPhoneNumberInputVisible && manualMobilepayPhoneNumber" type="button" class="btn btn-success" v-on:click="number"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import PhoneNumberInput from '~/components/PhoneNumberInput'
import { normalizeMobilepayPhoneNumber } from '~/lib/phone'

export default {
  props: ['pos', 'index', 'shopId', 'baseDomain', 'apiKey'],
  data () {
    return {
      manualMobilepayPhoneNumber: '',
      phoneNumberError: '',
      isPhoneNumberInputVisible: false,
      mobilePayQrCodeUrl: null,
    }
  },
  computed: {
    ...mapGetters([
      'mobilepayPhoneNumber',
      'mobilepayToken',
    ]),
  },
  methods: {
    async loadMobilePayQrCodeUrl () {
      let response 
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/pos/' + this.pos + '.json?mobilepayqrcode=true&apikey=' + this.apiKey)
      } catch (e) {
        console.log(e)
        return
      }
      return response.data
    },
    enablePhoneNumberInput () {
      this.isPhoneNumberInputVisible = true
      nextTick(() => {
        if (this.$refs && this.$refs.mobilepayphone) {
          this.$refs.mobilepayphone.focus()
        }
      })
    },
    number () {
      const phone = normalizeMobilepayPhoneNumber(this.manualMobilepayPhoneNumber)
      if (!phone) {
        this.phoneNumberError = this._('Check the phone number. Include the country code if the number is not Finnish.')
        return
      }
      this.phoneNumberError = ''
      this.$emit('number', phone)
    },
    close () {
      this.$emit('close')
    },
  },
  components: {
    PhoneNumberInput
  },
  watch: {
    manualMobilepayPhoneNumber () {
      this.phoneNumberError = ''
    },
    mobilepayPhoneNumber (newVal) {
      if (newVal) {
        this.$emit('number', newVal)
      }
    },
    mobilepayToken (newVal) {
      if (newVal) {
        this.$emit('token', newVal)
      }
    },
  },
  async mounted () {
    this.$socket.emit('message', {
      type: 'startMobilepayIdentification',
      data: {},
      shopId: this.$store.state.shopId,
      pos: this.pos,
      index: this.index
    })
    this.mobilePayQrCodeUrl = await this.loadMobilePayQrCodeUrl()
  },
  beforeUnmount () {
    this.mobilePayQrCodeUrl = null
    this.$socket.emit('message', {
      type: 'stopMobilepayIdentification',
      data: {},
      shopId: this.$store.state.shopId,
      pos: this.pos,
      index: this.index
    })
  }
}
</script>
